module.exports = __webpack_public_path__ + "static/publish_737x513-6816744977cedea76dac07cc052cd54f.webp";